import * as React from "react";
import useDidUpdateEffect from "../hooks/useDidUpdateEffect";
import { useLocation } from "react-router";

type RouteStateContextType = [any, (state: any) => void];

const RouteStateContext = React.createContext(
  ([] as any) as RouteStateContextType
);

const RouteStateProvider: React.FC = ({ children }) => {
  const location = useLocation();
  const [routeState, setRouteState] = React.useState<any>(null);

  useDidUpdateEffect(() => {
    const hasRouteStored =
      routeState && routeState.storedPath && routeState.redirectedPath;
    const shouldKeepRouteState =
      hasRouteStored &&
      ((routeState.storedPath === location.pathname &&
        routeState.redirectedPath !== location.pathname) ||
        (routeState.storedPath !== location.pathname &&
          routeState.redirectedPath === location.pathname));

    if (!shouldKeepRouteState) {
      setRouteState(null);
    }
  }, [location.pathname]);

  return (
    <RouteStateContext.Provider value={[routeState, setRouteState]}>
      {children}
    </RouteStateContext.Provider>
  );
};

export { RouteStateContext, RouteStateProvider };



// WEBPACK FOOTER //
// ./src/share/context/RouteStateProvider.tsx